<template>
  <div class="box">
    <template v-if="state === 0">
      <div class="fa-2x loading-spinner-box">
        <i class="fas fa-sync fa-spin"></i>
      </div>
    </template>
    <template v-if="state === 1">
      <ToolPanel
        v-model="sorting"
        :config="TOOLPANEL_CONFIG"
        @force-reload="loadFolders()"
      ></ToolPanel>
      <Node v-if="rootNode !== false"
            :data="sortedRootNode"
            :sorting="sorting"
            :autoOpenDepth="sorting.forceOpen ? 9999 : 1"
            :parentPath="basePath"
      ></Node>
    </template>
    <template v-if="state === 2">
      <span class="errorMsg">{{ errorMsg }}</span>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import Node from './node'
import ToolPanel from './tool-panel'
import { czSorter } from 'CORE/utils/sorters'
import Axios from 'axios'

const DEFAULT_SORTING = {
    alphabetical: true,
    foldersFirst: true,
    forceOpen: false,
}

const TOOLPANEL_CONFIG = [
    {
        key: 'alphabetical',
        default: _ => true,
        type: 'SWITCH',
        styleByValue: {
            'true': {
                fas: 'fa-sort-alpha-down',
            },
            'false': {
                fas: 'fa-sort-alpha-up-alt',
            },
        },
        tooltip: 'Abecední řazení vzestupně nebo sestupně',
    },
    {
        key: 'foldersFirst',
        default: _ => true,
        type: 'SWITCH',
        styleByValue: {
            'true': {
                fas: 'fa-folder',
            },
            'false': {
                fas: 'fa-font',
            },
        },
        tooltip: 'Sortovat složky jako první nebo vše řadit abecedně',
    },
    {
        key: 'forceOpen',
        default: _ => true,
        type: 'SWITCH',
        styleByValue: {
            'true': {
                fas: 'fa-folder-minus',
            },
            'false': {
                fas: 'fa-folder-plus',
            },
        },
        tooltip: 'Vynutit otevření/zavření všech složek všechny složky',
    },
    {
        key: 'reload',
        default: _ => true,
        type: 'ACTION',
        emit: 'force-reload',
        style: {
            fas: 'fa-sync',
        },
        tooltip: 'Znovu načíst složky ze samby',
    },
]

export default {
    name: 'FilesBrowser',
    components: {
        Node,
        ToolPanel,
    },
    props: {
        baseFolder: {
            required: false,
            type: String,
            default: _ => null,
        },
        basePath: {
            required: false,
            type: String,
            default: _ => '//',
        },
    },
    data() {
        return {
            sorting: DEFAULT_SORTING,
            rootNode: false,
            state: 0,
            errorMsg: undefined,
        }
    },
    computed: {
        sortedRootNode() {
            return sortNode(this.rootNode, this.sorting)
        },
        TOOLPANEL_CONFIG() {
            return TOOLPANEL_CONFIG
        },
    },
    async mounted() {
        try {
            await this.loadFolders()
        } catch (e) {
            const apiMsg = _.get(e.response, 'data.errormsg', 'Neznama chyba')
            this.errorMsg = `Nepovedlo se načíst soubory. [${apiMsg}]`
            this.state = 2
        }
    },
    methods: {
        async loadFolders() {
            const protocol = _.get(this.$store.getters.settings, 'modules.files.protocol', window.location.protocol)
            const hostname = _.get(this.$store.getters.settings, 'modules.files.hostname', window.location.hostname)
            // const port = _.get(this.$store.getters.settings, 'modules.files.port', '5000')
            const url = `${protocol}://${hostname}/${this.baseFolder}`
            this.state = 0
            this.rootNode = {
                'type': 'FOLDER',
                'name': this.baseFolder,
                'children': _.get(await Axios.get(url), 'data'),
            }
            this.state = 1
        },
    },
}

const sortNode = (node, sorting) => {
    sorting = _.defaults(sorting, DEFAULT_SORTING)
    if (_.size(_.get(node, 'children', [])) > 0) {
        node.children = _
            .chain(node.children)
            .map(n => sortNode(n, sorting))
            .sortWith((a, b) => czSorter(sorting.alphabetical ? 'asc' : 'desc')(...[a, b].map(c => _.get(c, 'name'))))
            .orderBy(n => sorting.foldersFirst ? _.get(n, 'type') === 'FOLDER' ? 0 : 1 : 0)
            .value()
    }
    return node
}
</script>

<style scoped>
.box {
    min-width: 400px;
    background-color: white;
    padding: 10px;
    max-height: 75vh;
    overflow: scroll;
}
.controls {
    width: 100%;
    height: 30px;
}
.btn:focus {
    box-shadow: none;
}
.loading-spinner-box {
    color: var(--secondary);
    margin: 10px auto 10px 10px;
}
.errorMsg {
    color: firebrick;
    font-weight: bold;
}
</style>

